import moment from "moment"

export class ReqRecruitmentItem_SalaryBase {
    /*

        Name,           //姓名
        Job,            //職務
        BaseSalary,     //底薪
        AttendanceDay,  //出勤天數
        OvertimePay,    //加班
        AbsenceAmout,   //請假
        SalaryAddAmount,    //加項
        SalarySubtractAmount,   //減項
        Salary,         //應付薪資
        PreServiceFee,  //服務費-未扣保費
    */
    constructor({ Recruitment, caseInfo, PositionInfo, startDate, endDate }) {
        if(PositionInfo === undefined)
        return
        this.Recruitment = Recruitment
        this.caseInfo = caseInfo
        this.PositionInfo = PositionInfo
        this.startDate = startDate
        this.endDate = endDate
        this.dates = startDate + "～" + endDate
        if (Recruitment !== undefined) {
            this.customerPositionId = Recruitment.customerPositionId || ""  //職缺Id
            this.caseContractor = Recruitment.caseContractor || ""          //外派員工Id
            this.Name = Recruitment.caseContractorName || ""                //姓名
        }
        this.BaseSalary = 0
        if (PositionInfo !== undefined) {
            this.Job = PositionInfo.job || ""                               //職務
            this.BaseSalary = parseInt(PositionInfo.wageInfo.MonthlySalary) || 0      //底薪
        }
        this.AttendanceDay = 0                                          //出勤天數
        this.AbsenceItems = []                                          //請假項目
        this.AbsenceAmout = 0                                          //請假金額
        this.initAbsenceItems()
        this.SalaryAddItems = []                                        //加項項目
        this.SalaryAddAmount = 0                                        //加項金額
        this.initSalaryAddItems()
        this.SalarySubtractItems = []                                   //減項項目
        this.SalarySubtractAmount = 0                                   //減項金額
        this.initSalarySubtractItems()
    }

    fromJson(jsonData) {
        this.Recruitment = jsonData.Recruitment
        this.caseInfo = jsonData.caseInfo
        this.PositionInfo = jsonData.PositionInfo
        this.startDate = jsonData.startDate
        this.endDate = jsonData.endDate
        this.dates = jsonData.dates
        this.customerPositionId = jsonData.Recruitment.customerPositionId || ""  //職缺Id
        this.caseContractor = jsonData.Recruitment.caseContractor || ""          //外派員工Id
        this.Name = jsonData.Recruitment.caseContractorName || ""                //姓名
        this.Job = jsonData.PositionInfo.job || ""                               //職務
        // console.log(jsonData.PositionInfo.wageInfo)
        this.BaseSalary = parseInt(jsonData.PositionInfo.wageInfo.MonthlySalary) || 0      //底薪
        // console.log(this.BaseSalary)
        this.AttendanceDay = jsonData.AttendanceDay                                          //出勤天數
        this.AbsenceItems = jsonData.AbsenceItems                                          //請假項目
        this.AbsenceAmout = jsonData.AbsenceAmout                                          //請假金額
        this.SalaryAddItems = jsonData.SalaryAddItems                                        //加項項目
        this.SalaryAddAmount = jsonData.SalaryAddAmount                                        //加項金額
        this.SalarySubtractItems = jsonData.SalarySubtractItems                                   //減項項目
        this.SalarySubtractAmount = jsonData.SalarySubtractAmount   
        this.Salary = jsonData.Salary                                                 //應付薪資
        this.PreServiceFee = jsonData.PreServiceFee                                          //服務費-未扣保費
        this.hourlySalary = jsonData.hourlySalary
        this.MonthlySalary = jsonData.MonthlySalary
        // this.setSalary()
    }

    //設定請假金額
    setAbsenceAmout(AbsenceAmout) {
        this.AbsenceAmout = AbsenceAmout
    }

    //請假初始化
    initAbsenceItems() {
        this.AbsenceItems.push(new ReqAbsenceItem({ key: 'SpecialLeave', name: "特休", proportions: 0, hours: 0, amount: 0 }))
        this.AbsenceItems.push(new ReqAbsenceItem({ key: 'SickLeave', name: "病假", proportions: 0.5, hours: 0, amount: 0 }))
        this.AbsenceItems.push(new ReqAbsenceItem({ key: 'CrampLeave', name: "生理假", proportions: 0.5, hours: 0, amount: 0 }))
        this.AbsenceItems.push(new ReqAbsenceItem({ key: 'AbsenceLeave', name: "事假", proportions: 1, hours: 0, amount: 0 }))
        this.AbsenceItems.push(new ReqAbsenceItem({ key: 'OtherAmount', name: "其他假", amount: 0 }))
    }

    //請假總計
    setAbsenceItems(AbsenceItems) {
        this.AbsenceItems = AbsenceItems
        var AbsenceAmout = 0
        AbsenceItems.map(item => (
            // AbsenceAmout += this.hourlySalary * item.proportions * item.hours
            AbsenceAmout += item.amount
        ))
        this.AbsenceAmout = AbsenceAmout
    }

    //加項初始化 
    initSalaryAddItems() {
        if (this.PositionInfo === undefined)
            return
        this.PositionInfo.wageInfo.SalaryAddItem.map((item) => (
            this.SalaryAddItems.push(new ReqSalaryItem({ key: item.id, name: item.text }))
        ))
    }
    //加項總計
    setSalaryAddItems(SalaryAddItems) {
        this.SalaryAddItems = SalaryAddItems
        var amount = 0
        SalaryAddItems.map(item => (
            amount += item.amount
        ))
        this.SalaryAddAmount = amount
    }

    //減項初始化
    initSalarySubtractItems() {
        if (this.PositionInfo === undefined)
            return
        this.PositionInfo.wageInfo.SalarySubtractItem.map((item) => (
            this.SalarySubtractItems.push(new ReqSalaryItem({ key: item.id, name: item.text }))
        ))
    }
    //減項總計
    setSalarySubtractItems(SalarySubtractItems) {
        this.SalarySubtractItems = SalarySubtractItems
        var amount = 0
        SalarySubtractItems.map(item => (
            amount += item.amount
        ))
        this.SalarySubtractAmount = amount
    }


    setDate() {
        if (this.caseInfo === undefined)
            return
        // console.log(moment(this.startDate))
        // console.log(moment(this.caseInfo.caseOnBoardDate))  
        var startDiff = moment(this.startDate).diff(moment(this.caseInfo.caseOnBoardDate), 'days')  //上班日與開始日差幾天
        // console.log(startDiff)
        if (startDiff <= 0) {
            // this.sDay = moment(this.startDate).format('YYYY/MM/DD')     //實際開始日
            this.sDay = moment(this.caseInfo.caseOnBoardDate).format('YYYY/MM/DD')  //實際開始日
        } else {
            this.sDay = moment(this.startDate).format('YYYY/MM/DD')
        }
        // console.log(this.sDay)
        if (this.caseInfo.caseResignDate === "") {
            this.eDay = moment(this.endDate).format('YYYY/MM/DD')       //實際結束日
        } else {
            this.eDay = moment(this.caseInfo.caseResignDate).format('YYYY/MM/DD')   //實際結束日
        }
        this.AttendanceDay = moment(this.eDay).diff(moment(this.sDay), 'days') + 1  //出勤天數
    }
}

//加減項項目
export class ReqSalaryItem {
    constructor({ key, name, amount = 0 }) {
        this.key = key
        this.name = name
        this.amount = amount
    }
    fromJson(jsonData) {
        this.key = jsonData.key
        this.name = jsonData.name
        this.amount = jsonData.amount
    }
    setAmount(amount) {
        this.amount = amount
    }
}

//請假項目
export class ReqAbsenceItem {
    constructor({ key, name, proportions, hours = 0, amount = 0 }) {
        this.key = key
        this.name = name
        this.proportions = proportions  //比例
        this.hours = hours              //小時
        this.amount = amount            //金額
        this.hourlySalary = 0           //時薪  
    }
    setHourlySalary(hourlySalary) {
        this.hourlySalary = hourlySalary      //時薪
    }
    setAmount({ hours, amount }) {
        this.hours = hours
        if (amount === undefined) {
            var h = Math.round(parseFloat(hours) * this.proportions * parseFloat(this.hourlySalary))
            if (!isNaN(h)) {
                this.amount = h             //總計
            }
        } else {
            this.amount = parseInt(amount)
        }
    }
    fromJson(jsonData) {
        this.key = jsonData.key
        this.name = jsonData.name
        this.proportions = jsonData.proportions  //比例
        this.hours = jsonData.hours || 0              //小時
        this.amount = jsonData.amount || 0         //金額
        this.hourlySalary = jsonData.hourlySalary || 0  //時薪
    }
}